import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useState, useCallback } from "react";
const ToastContext = createContext({
    toasts: [],
    showToast: () => { },
    dismissToast: () => { }
});
export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);
    const showToast = useCallback((message, type = "info") => {
        const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        setToasts((prev) => [...prev, { id, message, type }]);
        setTimeout(() => {
            setToasts((prev) => prev.filter((t) => t.id !== id));
        }, 4000);
    }, []);
    const dismissToast = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);
    return _jsx(ToastContext.Provider, { value: { toasts, showToast, dismissToast }, children: children });
};
export default ToastContext;
